import { ExperimentUtil } from 'client/utils/experiment/experiment-util';

export const SHOP_5067_SRP_TOP_CAMPAIGN = 'shop-5067-srp-top';

export const getShop5067SrpTopRecipe = state =>
  ExperimentUtil.getForcedOrAssignedRecipeName({
    state,
    campaignName: SHOP_5067_SRP_TOP_CAMPAIGN,
    defaultVal: 'ctrl',
  });

export const isShop5067SrpTopEnabled = recipe => recipe === 'chal1' || recipe === 'chal2';
